module.exports = __webpack_public_path__ + "img/footer01.ebc4750b.png";